const isValidUrl = url => {
  let urlToCheck;

  try {
    urlToCheck = new URL(url);
  } catch (_) {
    return false;
  }

  return urlToCheck.protocol === 'http:' || urlToCheck.protocol === 'https:';
};

export default isValidUrl;
